import { isReadOnly, useAuth } from 'src/composables/app/useAuth'

import { hasPermission } from 'src/services/helpers/auth.helper'
import { notifyService } from 'src/services/app/notify.service'
import { NOTIFICATION_MESSAGES } from 'src/services/consts/notification.const'
import { ROUTES } from 'src/services/consts/routes.const'

export default function setupAuthGuard(router) {
  router.beforeEach(async (to) => {
    const { user, setRedirectRoute, logout, initializeFromStorage } = useAuth()
    // 1) If the route does NOT require auth, just proceed
    if (!to.meta.requiresAuth) {
      return true
    }

    // 2) Ensure auth state is initialized
    await initializeFromStorage()

    // 3) If route requires auth but user is not logged in
    if (!user.value?.id) {
      // Save the redirect route before forcing login
      setRedirectRoute(to.fullPath)
      notifyService.error(NOTIFICATION_MESSAGES.unauthenticated)
      logout({ clearRedirect: false }) // This will unsubscribe and clear storage
      return '/' + ROUTES.LOGIN
    }

    // 4) If the route requires Admin privileges
    if (to.meta.requiresAdmin && !hasPermission('admin', user.value)) {
      notifyService.error(NOTIFICATION_MESSAGES.unauthorized)
      return '/'
    }

    // 5) If the route requires write access and the user is read-only
    if (to.meta.requiresWrite && isReadOnly.value) {
      notifyService.error(NOTIFICATION_MESSAGES.unauthorized)
      return { name: ROUTES.COMPANY_INFO, params: { id: to.params.id } }
    }

    // 6) If all checks pass, proceed to the route
    return true
  })
}
